import intl from 'react-intl-universal';
import { readableDateTimeFormat } from 'utils/dateTime';
import localData from 'utils/localData';
import { Button } from '@mui/material';
import { USER_DATA } from 'shared/constants/users';
import PropTypes from 'prop-types';
import { getUserPreferredTimezone } from 'utils/formatTime';

export const TitleColumn = () => {
  return {
    header: intl.get('kenshin_received_history_column_label_title'), // display name
    accessorKey: 'title',
    size: 50,
    enableClickToCopy: true,
    enableColumnFilter: true,
    filterFn: 'fuzzy',
    filterVariant: 'text',
    enableColumnActions: false,
  };
};

export const CreatedAtColumn = () => {
  return {
    header: intl.get('kenshin_received_history_column_label_created_at'),
    accessorKey: 'createdAt',
    size: 50,
    enableColumnActions: false,
    enableColumnFilter: false,
    Cell: ({ cell }) => {
      const createdAt = cell.getValue();
      const lang = localData.get(USER_DATA.PREFFERED_LANGUAGE);
      const timeZone = getUserPreferredTimezone();
      return readableDateTimeFormat(createdAt, lang, timeZone);
    },
  };
};

export const OthersColumn = ({ handleOpenIssueDetails }) => {
  return {
    header: intl.get('kenshin_received_history_column_label_others'),
    accessorKey: 'id',
    size: 100,
    enableSorting: false,
    enableColumnActions: false,
    enableColumnFilter: false,
    muiTableBodyCellProps: {
      onClick: (e) => e.stopPropagation(),
    },
    Cell: ({ renderedCellValue }) =>
      othersCell({ renderedCellValue, handleOpenIssueDetails }),
  };
};

const othersCell = ({ renderedCellValue, handleOpenIssueDetails }) => {
  const issueId = renderedCellValue;
  return (
    <Button
      variant="contained"
      color="primary"
      style={{ color: 'white' }}
      onClick={() => {
        handleOpenIssueDetails(issueId);
      }}>
      {intl.get('case_list_button_view')}
    </Button>
  );
};

othersCell.propTypes = {
  renderedCellValue: PropTypes.string.isRequired,
  handleOpenIssueDetails: PropTypes.func.isRequired,
};
